import type { ApprovalChain } from '../approval-chain.model';

export const MORTGAGE_DEED_OF_GRANT_CHAIN: ApprovalChain = {
  id: 'mortgage-deed-of-grant',
  label: 'Mortgage Deed of Grant',
  applicationTypes: ['MORTGAGE_DEED_OF_GRANT'],
  steps: [],
};
